export const OrganizationSelectIdentifier = 'serviceDeskOrganizationSelect';
